module.exports = "/assets/data/7bb73a31f3f5c5e49d30c2e2e0b9202b-HU16.data.json";